export default "__VITE_ASSET__CI$ScPtG__"